import React, { FC } from 'react'

import {
  IndexLayoutLoading as BaseIndexLayoutLoading,
  Variant,
} from 'components/IndexLayout'

export const IndexLayoutLoading: FC<{ variant?: Variant }> = ({ variant }) => (
  <BaseIndexLayoutLoading variant={variant} />
)
